import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Col, Form, Row } from "react-bootstrap";
import CheckoutSteps from "../../Components/CheckoutSteps";
import { saveShippingAddress } from "../../store/actions/cartActions";
import { useNavigate } from "react-router-dom";

function ShippingScreen(props) {
  const cart= useSelector(state=>state.cart);
  const {shippingAddress} = cart;
  const [fullName, setFullName] = useState(shippingAddress.fullName || '');
  const [email, setEmail] = useState(shippingAddress.email || '');
  const [address, setAddress] = useState(shippingAddress.address || '');
  const [city, setCity] = useState(shippingAddress.city || '');
  const [country, setCountry] = useState(shippingAddress.country || '');
  const [postalCode, setPostalCode] = useState(shippingAddress.postalCode || '');


  const userSignIn = useSelector((state) => state.userSignin);
  const { cartItems } = cart;
  const { userInfo } = userSignIn;
  const navigate = useNavigate();
  if(!userInfo){
    navigate('/signin')
  }

  useEffect(() => {
    if(cartItems.length===0){
      navigate('/')
    }
  }, [navigate,cartItems]);
  
  

  const dispatch = useDispatch();
  
  const submitHandler = (e) => {
    e.preventDefault();

    dispatch(
      saveShippingAddress({
        fullName,
        email,
        address,
        city,
        country,
        postalCode,
      })
    );

    navigate("/payment");
  };
  return (
    <div>
      <CheckoutSteps step1 step2 />
      <div className="shippingForm container my-3">
        <div className="shippingHeading my-5">
          <h2>Shipping</h2>
        </div>
        <Form onSubmit={submitHandler}>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="formGridName">
              <Form.Label>Full Name*</Form.Label>
              <Form.Control
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                required
                type="text"
                placeholder="Name"
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridEmail">
              <Form.Label>Email*</Form.Label>
              <Form.Control
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                type="email"
                placeholder="Enter email"
              />
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="formGridAddress1">
              <Form.Label>Address*</Form.Label>
              <Form.Control
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                required
                placeholder="e.g khayaban-e-street"
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} controlId="formGridCountry">
              <Form.Label>Country*</Form.Label>
              <Form.Control
                value={country}
                onChange={(e) => setCountry(e.target.value)}
                type="text"
                placeholder="Enter Country"
                required
              />
            </Form.Group>

            <Form.Group as={Col} controlId="formGridCity">
              <Form.Label>City*</Form.Label>
              <Form.Control
                value={city}
                onChange={(e) => setCity(e.target.value)}
                type="text"
                placeholder="Enter City"
                required
              />
            </Form.Group>

            <Form.Group as={Col} controlId="formGridZip">
              <Form.Label>Postal Code</Form.Label>
              <Form.Control
                value={postalCode}
                onChange={(e) => setPostalCode(e.target.value)}
                type="number"
                placeholder="Enter Postal code"
              />
            </Form.Group>
          </Row>

          <Button
            type="submit"
            variant="contained"
            className="w-100 bg-warning text-dark"
          >
            Go To Next Step
          </Button>
        </Form>
      </div>
    </div>
  );
}

export default ShippingScreen;
